<template>
  <v-row no-gutters :style="{ 'min-height': '90vh' }">
    <v-col class="px-4 text-center" style="padding-bottom: 200px;">
      <transition name="slide-fade" mode="out-in">
        <h1
          class="text-h3 text-sm-h2 text-md-h1 primary--text"
          :key="'title' + flow_active"
        >
          {{ flow[flow_active].title }}
        </h1>
      </transition>
      <transition name="fade" mode="out-in">
        <p
          id="text"
          class="text-body-1 text-sm-h6 font-weight-light"
          :key="'text' + flow_active"
          v-html="flow[flow_active].text"
        ></p>
      </transition>

      <transition name="fade" mode="out-in">
        <div id="actions" :key="'actions' + flow_active">
          <v-btn
            v-show="flow_active == 1"
            color="primary"
            x-large
            @click="$store.commit('updateStateUser', { theme_modal: true })"
          >
            <v-icon class="mr-2">mdi-palette-outline</v-icon>
            Change Theme
          </v-btn>

          <v-btn
            v-show="flow_active == 2"
            color="primary"
            :disabled="$store.state.user.newsletter"
            x-large
            @click="$store.dispatch('newsletter', { subscribe: true })"
            :loading="$store.state.user.newsletter_loading"
          >
            <v-icon color="white" left v-if="$store.state.user.newsletter">
              mdi-check
            </v-icon>
            {{
              $store.state.user.newsletter
                ? "Already subscribed"
                : "Yes, please"
            }}
          </v-btn>

          <v-img
            class="d-block mx-auto rounded-xl elevation-3"
            v-if="flow_active == 3"
            max-width="300"
            :src="require('@/assets/allow_popups.png')"
          ></v-img>

          <Bookmarklet x-large v-if="flow_active == 4" />

          <v-btn
            v-show="flow_active == 5"
            color="primary"
            x-large
            target="_blank"
            to="/pricing"
          >
            learn more
          </v-btn>
        </div>
      </transition>
      <div id="buttons">
        <!-- prettier-ignore -->
        <v-btn text color="grey" x-large @click="previousFlow"> back </v-btn>

        <v-btn outlined color="primary" x-large class="mx-5" @click="nextFlow"
          >next</v-btn
        >
      </div>
    </v-col>
  </v-row>
</template>

<script>
import Bookmarklet from "../components/Bookmarklet";

export default {
  name: "Welcome",
  components: { Bookmarklet },
  metaInfo() {
    return this.generateMeta({ name: "welcome", path: this.$route.path });
  },
  data() {
    return {
      flow_active: 0,
      flow: [
        {
          title: "Welcome",
          text:
            "We are thrilled to see you onboard. A couple of things before we start...",
        },
        {
          title: "Customize Theme",
          text: "Your bookmarks, your style... You can always change later.",
        },
        {
          title: "Hear From Us?",
          text:
            "Do you want us to send emails about product updates and discounts? <br>You can change it later on your profile.",
        },
        {
          title: "Allow Pop-ups",
          text:
            "When you want to open multiple browser tabs in the future, you might need to allow pop-ups from Bookmark Expert on your browser.",
        },
        {
          title: "One-click Add URL Button",
          text:
            "Drag & drop below bookmarklet button to your browser's bookmarks bar for a one-click-add-url button. For mobile browsers, create a bookmark and copy paste below Quick-Add Address for a one-click-add-url button.",
        },
        {
          title: "Upgrade",
          text:
            "On the FREE plan, you can create a maximum of 50 links or folders. Want to upgrade?",
        },
        {
          title: "Let's Start",
          text: "Everything is ready! Enjoy Bookmark Expert!",
        },
      ],
    };
  },
  methods: {
    nextFlow() {
      if (this.flow_active == this.flowCount - 1) {
        this.$router.push("/bookmarks/0");
      } else {
        this.flow_active += 1;
      }
    },
    previousFlow() {
      if (this.flow_active > 0) {
        this.flow_active -= 1;
      }
    },
  },
  computed: {
    flowCount() {
      return this.flow.length;
    },
  },
};
</script>

<style>
h1 {
  margin-top: 10vh;
}
#text {
  margin-top: 5vh;
}
#buttons {
  margin-top: 10vh;
}
#actions {
  margin-top: 5vh;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter
/* .slide-fade-leave-active for <2.1.8 */ {
  transform: translateX(100px);
  opacity: 0;
}
.slide-fade-leave-to
/* .slide-fade-leave-active for <2.1.8 */ {
  transform: translateX(-100px);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
